import type { SVGProps } from 'react';

export const ExpandDiagonalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M14.8048 2.66653H19.9995C20.7355 2.66653 21.3328 3.2652 21.3328 3.99987V9.19587C21.3328 9.7372 21.0102 10.2212 20.5088 10.4279C20.3435 10.4959 20.1702 10.5292 19.9982 10.5292C19.6502 10.5292 19.3102 10.3932 19.0555 10.1372L17.1662 8.24787L15.0395 10.3745C14.8448 10.5705 14.5888 10.6679 14.3328 10.6679C14.0768 10.6679 13.8208 10.5692 13.6262 10.3745C13.2355 9.98387 13.2355 9.35053 13.6262 8.95987L15.7528 6.8332L13.8622 4.94253C13.4795 4.55853 13.3662 3.9892 13.5728 3.4892C13.7808 2.9892 14.2648 2.66653 14.8048 2.66653ZM8.95817 13.6265C9.34866 13.236 9.98159 13.2359 10.3723 13.626C10.7622 14.0167 10.7619 14.6495 10.3715 15.0399L8.24484 17.1665L10.1355 19.0572C10.5182 19.4412 10.6315 20.0105 10.4248 20.5105C10.2168 21.0105 9.73284 21.3332 9.19284 21.3332H3.99817C3.26217 21.3332 2.66484 20.7345 2.66484 19.9999V14.8052C2.66484 14.2639 2.98751 13.7799 3.48884 13.5732C3.98751 13.3652 4.56084 13.4812 4.94217 13.8639L6.83151 15.7532L8.95817 13.6265ZM10.3723 13.626C10.3725 13.6262 10.3727 13.6263 10.3728 13.6265L10.3718 13.6255C10.3719 13.6256 10.3721 13.6258 10.3723 13.626Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
